import { useTheme } from '@mui/material';

import {
  CELL_FONT_SIZE,
  CELL_HEIGHT,
  CELL_WIDTH,
  CUSTOM_PADDING,
  DAY_GRAY,
} from '~/components/EmployeeCalendar/data';
import { getNumber } from '~/utils/helpers/number';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      padding: theme.spacing(0.75, 1.5),
    },
    legendRow: {
      display: 'flex',
      gap: theme.spacing(1),
      width: '100%',
    },
    legend: {
      display: 'flex',
      gap: theme.spacing(0.5),
      alignItems: 'center',
    },
    legendSample: {
      width: `${CELL_WIDTH}px`,
      height: `${CELL_HEIGHT}px`,
      backgroundColor: DAY_GRAY,
      borderRadius: `${getNumber(theme.shape.borderRadius) + 1}px`,
      fontSize: CELL_FONT_SIZE,
      textAlign: 'center',
      padding: `${CUSTOM_PADDING}px`,
    },
    legendLabel: {},
    legendLabelHidden: {
      textDecoration: 'line-through',
      opacity: 0.5,
    },
    dividerVertical: {
      height: 'auto',
    },
  };
};
